import * as React from 'react';
import { ISearchCatalogItemSchema } from '@cian/api-models/monolith-python/cian-api/site/v1/search-regions-cities';

import { TRegionSearchCitiesState } from '../../../../types/redux';
import { IRegion } from '../../../../types/regions';

import { MountPopup } from '../../../../components/PopupViewer';
import { ClickOutside } from '../../../../components/outside';
import { Container } from '../../../../components/Container';
import { Input } from '../../../../components/Input';
import {
  SIZE_360, SIZE_WIDE,
} from '../../../../constants/sizes';
import { getEventValue, debounce } from '@cian/newbuilding-utils';
import { SelectionList } from '../../../../components/SelectionList';
import { DEFAULT_INPUT_TIMEOUT } from '../../../../constants/timeouts';

interface ICityModalInputState {
  isOpenSuggest: boolean;
  inputValue: string;
  currentRegion?: IRegion | ISearchCatalogItemSchema;
}

interface ICityModalInputProps {
  searchList: TRegionSearchCitiesState;
  onClick(region: { id: string, label: string }): void;
  onCloseSuggest(): void;
  onChange(value: string): void;
}

export class CityModalInput extends React.PureComponent<ICityModalInputProps, ICityModalInputState> {
  public state: Readonly<ICityModalInputState> = {
    isOpenSuggest: false,
    inputValue: '',
  };

  public render() {
    const {
      isOpenSuggest,
      inputValue,
    } = this.state;
    const {
      searchList = [],
    } = this.props;

    return (
      <MountPopup
        onScroll={this.handleCloseSuggest}
        placement="bottom"
        component={
          searchList.length && inputValue.length && isOpenSuggest &&
          <ClickOutside onOutside={this.handleCloseSuggest}>
            <Container
              shadow
              borderColor="gray_0"
              borderStyle="solid"
              backgroundColor="white"
              maxWidth={SIZE_WIDE}
              width={SIZE_360}
            >
              <SelectionList
                onClick={this.handleListClick}
                options={searchList.map(({displayName}, index) => ({ id: `${index}`, label: displayName}))}
                selectedItems={[]}
                simple
              />
            </Container>
          </ClickOutside>
        }
      >
        <Container
          width={SIZE_360}
          maxWidth={SIZE_WIDE}
        >
          <Input
            aria-label="Регион или город"
            onChange={(event: React.SyntheticEvent) => {this.handleInput(getEventValue(event)); }}
            placeholder="Введите регион или город"
            value={inputValue}
          />
        </Container>
      </MountPopup>
    );
  }

  private handleInput = (inputValue: string) => {
    this.setState({
      inputValue,
      isOpenSuggest: true,
    });

    this.handleInputChange(inputValue);

  }

  private handleInputChange = debounce(DEFAULT_INPUT_TIMEOUT, (inputValue: string) => {
    this.props.onChange(inputValue);
  });

  private handleCloseSuggest = () => {
    this.setState({ isOpenSuggest: false });
    this.props.onCloseSuggest();
  }

  private handleListClick = (options: { id: string, label: string }) => {
    this.props.onClick(options);
    this.setState({
      inputValue: '',
      isOpenSuggest: false,
    });
  }
}
